// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__7KoQy","skeleton_animate":"title_skeleton_animate__6Pjmf"};